import React from 'react';
import {FormGroup as MuiFormGroup} from '@mui/material';
import {FormGroupProps} from './FormGroupProps';

function FormGroup(props: FormGroupProps) {
  return <MuiFormGroup {...props} />;
}

export default FormGroup;
